import { z } from 'zod';

/**
 * Sanitized loyalty program for public API responses.
 * Excludes sensitive integration details like URLs and partner codes.
 */
export const LoyaltyProgramSchema = z.object({
  id: z.string(),
  programName: z.string(),
  currencyType: z.string(),
  currencyToPointsRatio: z.number(),
  createdAt: z.date(),
  updatedAt: z.date(),
});

export type LoyaltyProgram = z.infer<typeof LoyaltyProgramSchema>;
